import {useRef} from "../../../__snowpack__/pkg/react.js";
import {request} from "../../utils/request/index.js";
import {clearCache, useRequest, useUnmount, useUpdateEffect} from "../../../__snowpack__/pkg/ahooks.js";
export default function useQueryCategories(params, options) {
  const {channelId, countryCode} = params;
  const cacheKey = `${channelId}-${countryCode}-query-categories`;
  const ref = useRef({cacheKeys: new Set([cacheKey])});
  useUpdateEffect(() => {
    if (countryCode && channelId) {
      ref.current.cacheKeys.add(cacheKey);
    }
  }, [cacheKey]);
  useUnmount(() => {
    clearCache([...ref.current.cacheKeys]);
  });
  return useRequest((_params) => request.post("/saas/shop/get-categories", {
    channel: channelId,
    countryCode,
    ..._params
  }), {
    cacheKey,
    staleTime: -1,
    ready: !!countryCode && !!channelId,
    refreshDeps: [countryCode, channelId],
    ...options
  });
}
